<div class="toolbar-container" [class.primary]="color==='primary'">
    <ng-content select="app-toolbar-back"></ng-content>
    <a *ngIf="logoLinked && !title && logo" [routerLink]="['/admin']"><img class="toolbar-logo" src="/assets/images/logo/full.svg" alt=""></a>
    <img *ngIf="!logoLinked && !title && logo" class="toolbar-logo" src="/assets/images/logo/full.svg" alt="">
    <div *ngIf="title" class="toolbar-title">
        <img *ngIf="logo" src="/assets/images/logo/small.svg" alt="">
        <h1>{{title}}</h1>
    </div>
    <span class="remaining-space"></span>
    <ng-content></ng-content>
</div>